export default function() {
  // We ensure that we have https connection, valid manifest.json and service worker registration.
  // So, all we need to check for is `onbeforeinstallprompt` event in Chromium browsers.
  return ("onbeforeinstallprompt" in window) || global.helpers.isIosSafari()
}
